import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import classes from "./SalesConfigPanel.module.css";
import Checkbox from "../../framework/Checkbox";
import { useSelector } from "react-redux";
import NumberInput from "../../framework/NumberInput";
import { useContext } from "react";
import GlobalContext from "../../framework/GlobalContext";
import ConfigurationContext from "./ConfigurationContext";

export const PurchaseConfigPanel = (props) => {
  const {
    ENABLE_TCS_PER_PURCHASE,
    // ENABLE_IGST_PER_PURCHASE,
    // ENABLE_CHALLAN_BILL,
    // UPDATE_MIN_MAX_RACK,
    DISABLE_SAME_PURCHASE_INVOICE,
    SHOW_SCHEME_IN_PURCHASE,
    ENABLE_DUPLICATE_PURCHASE_PRINT,
    // ENABLE_CESS_PURCHASE,
    // ENABLE_COMPOSITE_SCHEME,
    // ENABLE_HSN_PURCHASE,
    DISABLE_HSN_UPDATE_FROM_PURCHASE_UPLOAD,
    // SUPER_ADMIN_ACCESS_FOR_SHORT_EXPIRY_PRODUCT,
    // ENABLE_DEMAND_BOOK_ON_PURCHASE_RETURN,
    DEFAULT_EXPIRY_MONTH,
    MAX_PURCHASE_QUANTITY,
    PRINT_BARCODE_ON_SAVE,
    MANDATE_RACK_FOR_PRINT,
  } = useSelector(
    (state) =>
      state.commonReducer.tabs[state.commonReducer.activeTabIndex].configData
  );
  const { formLabels } = useContext(ConfigurationContext);
  const { setCurrentComponent } = useContext(GlobalContext);
  const configEnableTcsRef = useRef();
  useEffect(() => {
    setCurrentComponent("purchase_config_enable_tcs");
    configEnableTcsRef?.current.focus({ preventScroll: true });
  }, [setCurrentComponent]);
  return (
    <div className={classes["salesconfigpanel-main-container"]}>
      <div className={classes["salesconfig-text-style"]}>Purchase Setting</div>
      <div className={classes["salesconfig-sub-container"]}>
        <div className={classes["salesconfig-left-container"]}>
          <div className={classes["salesconfig-margin-section"]}>
            <div className={classes["salesconfig-margin-text"]}>
              Tax Settings
            </div>

            <Checkbox
              id="purchase_config_enable_tcs"
              name="enableTcs"
              ref={configEnableTcsRef}
              label={formLabels?.ENABLE_TCS_PER_PURCHASE?.displayName}
              checked={ENABLE_TCS_PER_PURCHASE}
              onFocus={() => setCurrentComponent("purchase_config_enable_tcs")}
              onChange={(e) => {
                // setTcsPerPurchase(e.target.checked);
                props.handleFormChange(
                  "ENABLE_TCS_PER_PURCHASE",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "purchase_config_enable_tcs",
                  down: "purchase_config_disable_hsn_from_purchase_upload",
                  left: "purchase_config_enable_tcs",
                  right: "purchase_config_disable_hsn_from_purchase_upload",
                }),
              }}
            />
            <div className={classes["salesconfig-margin-details"]}>
              {/* <Checkbox
                id="sales_edit_patient_avoid_sms"
                name="disableOrderSMS"
                // ref={editPatientAvoidSmsRef}
                checked={enableIgstPerPurchase}
                // ref={editPatientActivateDiscountProgramRef}
                label="Enable IGST"
                //   onFocus={() =>
                //     setCurrentComponent("sales_edit_patient_activate_discount")
                //   }
                labelPlacement="start"
                onChange={(e) => {
                  setEnableIgstPerPurchase(e.target.checked);
                  props.handleFormChange(
                    "ENABLE_IGST_PER_PURCHASE",
                    e.target.checked,
                    "purchase"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "",
                    down: "sales_edit_patient_activate_loyalty",
                    left: "",
                    right: "sales_edit_patient_discount_program",
                  }),
                }}
              /> */}
              {/* <br /> */}
              {/* <Checkbox
                id="sales_edit_patient_avoid_sms"
                name="disableOrderSMS"
                // ref={editPatientAvoidSmsRef}
                checked={enableCessPurchase}
                label="Enable CESS"
                //   onFocus={() =>
                //     setCurrentComponent("sales_edit_patient_activate_discount")
                //   }
                onChange={(e) => {
                  setEnableCessPurchase(e.target.checked);
                  props.handleFormChange(
                    "ENABLE_CESS_PURCHASE",
                    e.target.checked,
                    "purchase"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "",
                    down: "sales_edit_patient_activate_loyalty",
                    left: "",
                    right: "sales_edit_patient_discount_program",
                  }),
                }}
              /> */}

              {/* <Checkbox
                id="sales_edit_patient_avoid_sms"
                name="disableOrderSMS"
                // ref={editPatientAvoidSmsRef}
                label="Business Registered for Composite Scheme"
                checked={enableCompositeScheme}
                //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
                onChange={(e) => {
                  setEnableCompositeScheme(e.target.checked);
                  props.handleFormChange(
                    "ENABLE_COMPOSITE_SCHEME",
                    e.target.checked,
                    "purchase"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "sales_edit_patient_address",
                    down: "",
                    left: "sales_edit_patient_credit_limit",
                    right: "sales_edit_patient_tb_details",
                  }),
                }}
              /> */}
              {/* <Checkbox
                id="sales_edit_patient_avoid_sms"
                name="disableOrderSMS"
                // ref={editPatientAvoidSmsRef}
                label="Enable HSN"
                checked={enableHsnPurchase}
                //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
                onChange={(e) => {
                  setEnableHsnPurchase(e.target.checked);
                  props.handleFormChange(
                    "ENABLE_HSN_PURCHASE",
                    e.target.checked,
                    "purchase"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "sales_edit_patient_address",
                    down: "",
                    left: "sales_edit_patient_credit_limit",
                    right: "sales_edit_patient_tb_details",
                  }),
                }}
              /> */}
              <Checkbox
                id="purchase_config_disable_hsn_from_purchase_upload"
                name="disableHsnUpdateFrompurchaseUpload"
                // ref={editPatientAvoidSmsRef}
                label={
                  formLabels?.DISABLE_HSN_UPDATE_FROM_PURCHASE_UPLOAD
                    ?.displayName
                }
                checked={DISABLE_HSN_UPDATE_FROM_PURCHASE_UPLOAD}
                onFocus={() =>
                  setCurrentComponent(
                    "purchase_config_disable_hsn_from_purchase_upload"
                  )
                }
                onChange={(e) => {
                  // setDisableHsnUpdateFromPurchaseUpload(e.target.checked);
                  props.handleFormChange(
                    "DISABLE_HSN_UPDATE_FROM_PURCHASE_UPLOAD",
                    e.target.checked,
                    "purchase"
                  );
                }}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "purchase_config_enable_tcs",
                    down: "purchase_config_disable_same_purchase_invoice",
                    left: "purchase_config_enable_tcs",
                    right: "purchase_config_disable_same_purchase_invoice",
                  }),
                }}
              />
            </div>
          </div>
          <div className={classes["salesconfig-discount-section"]}>
            <div className={classes["salesconfig-discount-settings-text"]}>
              Bill Settings
            </div>
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label="Enable Challan Bill"
              checked={enableChallanBill}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setChallanBill(e.target.checked);
                props.handleFormChange(
                  "ENABLE_CHALLAN_BILL",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label="Update Min/ Max/ Rack after a Purchase"
              checked={updateMinMaxRack}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setMinMaxRack(e.target.checked);
                props.handleFormChange(
                  "UPDATE_MIN_MAX_RACK",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}

            <Checkbox
              id="purchase_config_disable_same_purchase_invoice"
              name="disableSamepurchaseInvoice"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.DISABLE_SAME_PURCHASE_INVOICE?.displayName}
              checked={DISABLE_SAME_PURCHASE_INVOICE}
              onFocus={() =>
                setCurrentComponent(
                  "purchase_config_disable_same_purchase_invoice"
                )
              }
              onChange={(e) => {
                // setDisableSamePurchaseInvoice(e.target.checked);
                props.handleFormChange(
                  "DISABLE_SAME_PURCHASE_INVOICE",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "purchase_config_disable_hsn_from_purchase_upload",
                  down: "purchase_config_show_scheme_in_purchase",
                  left: "purchase_config_disable_hsn_from_purchase_upload",
                  right: "purchase_config_show_scheme_in_purchase",
                }),
              }}
            />

            <Checkbox
              id="purchase_config_show_scheme_in_purchase"
              name="showSchemeInPurchase"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.SHOW_SCHEME_IN_PURCHASE?.displayName}
              checked={SHOW_SCHEME_IN_PURCHASE}
              onFocus={() =>
                setCurrentComponent("purchase_config_show_scheme_in_purchase")
              }
              onChange={(e) => {
                //setShowSchemeInPurchase(e.target.checked);
                props.handleFormChange(
                  "SHOW_SCHEME_IN_PURCHASE",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "purchase_config_disable_same_purchase_invoice",
                  down: "purchase_config_show_scheme_in_purchase",
                  left: "purchase_config_disable_same_purchase_invoice",
                  right: "purchase_config_enable_duplicate_purchase_print",
                }),
              }}
            />

            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label="Enable Negative Purchase Discount"
              checked={enableNegativePurchaseInDiscount}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setNegativePurchaseInDiscount(e.target.checked);
                props.handleFormChange(
                  "ENABLE_NEGATIVE_PURCHASE_IN_DISCOUNT",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label="Require Super Admin Access when Short Expiry Product"
              checked={superAdminAccessForShortExpiryProduct}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setSuperAdminAccessForShortExpiryProduct(e.target.checked);
                props.handleFormChange(
                  "SUPER_ADMIN_ACCESS_FOR_SHORT_EXPIRY_PRODUCT",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label="Avoid Demand Book on Purchase Return"
              checked={enableDemandBookOnPurchaseReturn}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setDemandBookOnPurchaseReturn(e.target.checked);
                props.handleFormChange(
                  "ENABLE_DEMAND_BOOK_ON_PURCHASE_RETURN",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            /> */}
          </div>
        </div>
        <div className={classes["salesconfig-right-container"]}>
          <div className={classes["salesconfig-stocksetting-section"]}>
            <div className={classes["salesconfig-stocksetting-text"]}>
              Print and Email Settings
            </div>
            {/* Config not used in proper way.. */}
            {/* <Checkbox
              id="sales_edit_patient_avoid_sms"
              name="disableOrderSMS"
              // ref={editPatientAvoidSmsRef}
              label="Enable Purchase Print"
              checked={enablePurchasePrint}
              //  onFocus={() => setCurrentComponent("sales_edit_patient_avoid_sms")}
              onChange={(e) => {
                setPurchasePrint(e.target.checked);
                props.handleFormChange(
                  "ENABLE_PURCHASE_PRINT",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "sales_edit_patient_address",
                  down: "",
                  left: "sales_edit_patient_credit_limit",
                  right: "sales_edit_patient_tb_details",
                }),
              }}
            />
            <br /> */}

            <Checkbox
              id="purchase_config_enable_duplicate_purchase_print"
              name="enableDuplicatePurchasePrint"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.ENABLE_DUPLICATE_PURCHASE_PRINT?.displayName}
              checked={ENABLE_DUPLICATE_PURCHASE_PRINT}
              onFocus={() =>
                setCurrentComponent(
                  "purchase_config_enable_duplicate_purchase_print"
                )
              }
              onChange={(e) => {
                //setEnableDuplicatePurchasePrint(e.target.checked);
                props.handleFormChange(
                  "ENABLE_DUPLICATE_PURCHASE_PRINT",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "purchase_config_enable_duplicate_purchase_print",
                  down: "purchase_config_print_barcode_on_save",
                  left: "purchase_config_show_scheme_in_purchase",
                  right: "purchase_config_print_barcode_on_save",
                }),
              }}
            />

            <Checkbox
              id="purchase_config_print_barcode_on_save"
              name="printBarcodeOnSave"
              // ref={editPatientAvoidSmsRef}
              label={formLabels?.PRINT_BARCODE_ON_SAVE?.displayName}
              checked={PRINT_BARCODE_ON_SAVE}
              onFocus={() =>
                setCurrentComponent("purchase_config_print_barcode_on_save")
              }
              onChange={(e) => {
                //setBarcodeOnsave(e.target.checked);
                props.handleFormChange(
                  "PRINT_BARCODE_ON_SAVE",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "purchase_config_enable_duplicate_purchase_print",
                  down: "purchase_config_mandate_rack_barcode_print",
                  left: "purchase_config_enable_duplicate_purchase_print",
                  right: "purchase_config_mandate_rack_barcode_print",
                }),
              }}
            />
            <Checkbox
              id="purchase_config_mandate_rack_barcode_print"
              name="mandateRackForPrint"
              label={formLabels?.MANDATE_RACK_FOR_PRINT?.displayName}
              checked={MANDATE_RACK_FOR_PRINT}
              onFocus={() => {
                setCurrentComponent(
                  "purchase_config_mandate_rack_barcode_print"
                );
              }}
              onChange={(e) => {
                props.handleFormChange(
                  "MANDATE_RACK_FOR_PRINT",
                  e.target.checked,
                  "purchase"
                );
              }}
              inputProps={{
                "data-markers": JSON.stringify({
                  up: "purchase_config_print_barcode_on_save",
                  down: "purchase_config_default_expiry",
                  left: "purchase_config_print_barcode_on_save",
                  right: "purchase_config_default_expiry",
                }),
              }}
            />
          </div>

          <div className={classes["salesconfig-stocksetting-section"]}>
            <div className={classes["salesconfig-stocksetting-text"]}>
              Miscellaneous
            </div>

            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="purchase_config_default_expiry"
                name="defaultExpiryDays"
                value={DEFAULT_EXPIRY_MONTH}
                label={formLabels?.DEFAULT_EXPIRY_MONTH?.displayName}
                onFocus={() =>
                  setCurrentComponent("purchase_config_default_expiry")
                }
                onValueChange={(values, e) => {
                  // setdefaultExiryMonthFromNow(values.floatValue);
                  props.handleFormChange(
                    "DEFAULT_EXPIRY_MONTH",
                    values.floatValue,
                    "purchase"
                  );
                }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "purchase_config_mandate_rack_barcode_print",
                    down: "purchase_config_max_purchase_qty",
                    left: "purchase_config_mandate_rack_barcode_print",
                    right: "purchase_config_max_purchase_qty",
                  }),
                }}

                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              />
            </div>
            <div className={classes["salesconfig-textbox-wrapper"]}>
              <NumberInput
                id="purchase_config_max_purchase_qty"
                name="maxpurchaseQuantity"
                //.ref={maxPurchaseQuantityRef}
                value={MAX_PURCHASE_QUANTITY}
                label={formLabels?.MAX_PURCHASE_QUANTITY?.displayName}
                onFocus={() =>
                  setCurrentComponent("purchase_config_max_purchase_qty")
                }
                onValueChange={(values, e) => {
                  // setmaxPurchaseQuantity(values.floatValue);
                  props.handleFormChange(
                    "MAX_PURCHASE_QUANTITY",
                    values.floatValue,
                    "purchase"
                  );
                }}
                //onBlur={() => validateForm("distributorName", formState, errorState)}
                inputProps={{
                  "data-markers": JSON.stringify({
                    up: "purchase_config_default_expiry",
                    down: "purchase_config_max_purchase_qty",
                    left: "purchase_config_default_expiry",
                    right: "purchase_config_max_purchase_qty",
                  }),
                }}

                //   error={checkErrorStateExists(
                //     "purchase_edit_distributor_name",
                //     errorState
                //   )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
